import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Text } from 'components/v4';
import { Field } from 'formik';
import { useEffect, useState } from 'react';

import FieldToolTip from '@/components/forms/new/FieldToolTip';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const TrunkDropdown = ({
    section,
    accountScope,
    submitData,
    setPlatformNumber,
    errors,
    touched,
    darkMode,
    trunks = [],
    trunkList,
    trunkCount,
    isTrunkDisabled,
    platformID,
    setSelectedTrunk = () => {},
    isCurrentTrunkOC,
}) => {
    const singleTrunk = trunkCount === 1 ? trunkList[0] : undefined;
    const hasTrunkDropdown = trunkCount > 1;
    const platformIndex = submitData?.findIndex(
        (platform) => platform?.platformID === platformID,
    );
    const platform = submitData[platformIndex];

    const handleSelectChange = (item) => {
        setPlatformNumber((prev) => {
            const newPlatformNumbers = [...prev];

            newPlatformNumbers[platformIndex] = {
                ...platform,
                trunkID: item?.id,
                operatorConnectCallingProfileID: !isCurrentTrunkOC
                    ? null
                    : platform?.operatorConnectCallingProfileID,
                operatorConnectUsageID: !isCurrentTrunkOC
                    ? null
                    : platform?.operatorConnectUsageID,
            };
            return newPlatformNumbers;
        });
        setSelectedTrunk(item);
    };

    useEffect(() => {
        if (platform?.trunkID && Array.isArray(trunks)) {
            const selected = trunks.find(
                (trunk) => trunk.id === platform.trunkID,
            );
            setSelectedTrunk(selected);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [platform?.trunkID, trunks]);
    const [isHovered, setIsHovered] = useState(false);

    let renderTrunkField;
    if (isTrunkDisabled) {
        renderTrunkField = (
            <Stack direction="row" width="100%" alignItems="center" spacing={2}>
                {/* <Switch mb={0} isDisabled isChecked={false} /> */}
            </Stack>
        );
    }
    if (singleTrunk) {
        renderTrunkField = (
            <Stack direction="row" width="100%" alignItems="center" spacing={2}>
                <Text>
                    {platform?.trunkID === singleTrunk.id
                        ? singleTrunk?.name
                        : 'Not Allocated'}
                </Text>
            </Stack>
        );
    }
    if (hasTrunkDropdown) {
        renderTrunkField = (
            <Field
                component={DropDown}
                id={`${section}-trunk`}
                name={`${section}-trunk`}
                shownValue="name"
                currentId={platform?.trunkID}
                handleSelectChange={handleSelectChange}
                accountScope={accountScope}
                darkMode={darkMode}
                data={trunks}
                walkthroughid={
                    walkthroughIds.editNumbersGeneral.editPlatformNumbers
                        .ufTrunk
                }
            />
        );
    }
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                errors &&
                `${section}-trunk` in errors &&
                touched &&
                touched[`${section}-trunk`]
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>Trunk</FormLabel>
                </Box>

                {renderTrunkField}
                {isHovered && (
                    <FieldToolTip
                        label="Trunk attached to the Number"
                        ariaLabel={`${section}-trunk-tooltip`}
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default TrunkDropdown;
